import React, { useEffect, createElement } from 'react';
import { Check } from 'lucide-react';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function BuggyLanding() {
  // Initialize Meta Pixel
  useEffect(() => {
    // Check if pixel is already initialized
    if (window.fbq) return;
    // Initialize fbq function
    const fbq = function (...args: any[]) {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        ;
        (fbq as any).queue.push(args);
      }
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    window._fbq = fbq;
    // Load the Facebook Pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Initialize pixel and track page view
    window.fbq('init', '110126979535877');
    window.fbq('track', 'PageView');
  }, []);
  // Function to track Lead event
  const trackLead = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  };
  // CSS Variables for the theme - Enhanced with more vibrant colors
  const themeStyles = {
    '--bg': '#F7F2E8',
    '--text': '#1B1B1B',
    '--muted': '#5B5B5B',
    '--green': '#1F5E43',
    '--green2': '#2F7A57',
    '--green-bright': '#3A9B6F',
    '--mint': '#CFE7D7',
    '--mint-bright': '#A8E6C1',
    '--gold': '#D6A44C',
    '--gold-bright': '#F4C563',
    '--orange': '#FF8C42',
    '--blue': '#4A90E2',
    '--purple': '#9B6FE8',
    '--card': '#FFFFFF',
    '--border': 'rgba(31,94,67,.18)',
    '--shadow': '0 10px 30px rgba(0,0,0,.08)',
    '--radius': '18px',
    '--radius2': '26px',
    '--max': '1120px',
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Inter, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"'
  } as React.CSSProperties;
  const CHECKOUT_URL = 'https://wa.me/528149826693?text=Quiero%20suscribirme';
  const WHATSAPP_URL = 'https://wa.me/528149826693?text=Quiero%20m%C3%A1s%20informaci%C3%B3n';
  return <div style={themeStyles} className="min-h-screen text-[var(--text)] font-sans selection:bg-[var(--mint-bright)] selection:text-[var(--green)]" data-id="element-2">
      {/* Global Styles for specific elements that are cleaner in CSS */}
      <style data-id="element-3">{`
        body { margin: 0; }
        .bg-theme-gradient {
          background: radial-gradient(1200px 600px at 20% 0%, rgba(168,230,193,.65), transparent 60%),
                      radial-gradient(900px 500px at 90% 10%, rgba(244,197,99,.28), transparent 55%),
                      radial-gradient(800px 400px at 50% 100%, rgba(155,111,232,.12), transparent 70%),
                      var(--bg);
        }
        details > summary { list-style: none; }
        details > summary::-webkit-details-marker { display: none; }
        .hero-card-gradient::before {
          content: "";
          position: absolute;
          inset: -80px -80px auto auto;
          width: 240px;
          height: 240px;
          background: radial-gradient(circle at 30% 30%, rgba(168,230,193,.95), rgba(244,197,99,.3) 50%, transparent 70%);
          transform: rotate(25deg);
          pointer-events: none;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 20px rgba(58,155,111,.3); }
          50% { box-shadow: 0 0 30px rgba(58,155,111,.6); }
        }
        .pulse-glow {
          animation: pulse-glow 2s ease-in-out infinite;
        }
      `}</style>

      <div className="bg-theme-gradient min-h-screen flex flex-col" data-id="element-4">
        {/* NAV */}
        <nav className="sticky top-0 z-30 backdrop-blur-md bg-[#F7F2E8]/75 border-b border-[rgba(31,94,67,.10)] shadow-sm" data-id="element-5">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-6">
            <div className="flex items-center justify-between py-[14px] gap-4" data-id="element-7">
              <a href="#top" className="flex items-center gap-3 no-underline group" aria-label="Buggy" data-id="element-8">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[var(--mint-bright)] to-[var(--green-bright)] grid place-items-center overflow-hidden border-2 border-[var(--green)] text-white font-black text-xl shadow-lg group-hover:scale-110 transition-transform" data-id="element-9">
                  B
                </div>
                <div className="font-extrabold tracking-wide text-lg bg-gradient-to-r from-[var(--green)] to-[var(--green-bright)] bg-clip-text text-transparent" data-id="element-10">
                  Buggy
                </div>
              </a>

              <div className="hidden md:flex items-center gap-4 text-[14px] font-semibold text-[var(--muted)]" data-id="element-11">
                <a href="#faq" className="hover:text-[var(--green)] transition-colors" data-id="element-12">
                  FAQs
                </a>
                <a href={WHATSAPP_URL} onClick={trackLead} className="hover:text-[var(--green)] transition-colors" data-id="element-13">
                  Contacto
                </a>
              </div>
            </div>
          </div>
        </nav>

        {/* HERO */}
        <section id="top" className="pt-14 pb-6" data-id="element-14">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-15">
            <div className="grid grid-cols-1 md:grid-cols-[1.1fr_0.9fr] gap-[30px] items-center max-[940px]:grid-cols-1 max-[940px]:gap-[22px]" data-id="element-16">
              {/* Hero Content */}
              <div data-id="element-17">
                <span className="pill inline-flex items-center gap-2.5 px-3 py-2 rounded-full bg-gradient-to-r from-[var(--mint-bright)] to-[var(--mint)] border-2 border-[var(--green-bright)] text-[var(--green)] font-bold text-[13px] shadow-md" data-id="element-18">
                  ✨ Plan anual · 1 envío con todo para 4 aplicaciones
                </span>

                <h1 className="text-[clamp(34px,4vw,54px)] leading-[1.05] mt-3 mb-3.5 tracking-[-0.6px] bg-gradient-to-br from-[var(--green)] via-[var(--green-bright)] to-[var(--green2)] bg-clip-text text-transparent font-black" data-id="element-19">
                  Di adiós a los bichos.
                  <br data-id="element-20" />
                  Hazlo tú con Buggy.
                </h1>

                <p className="text-[clamp(18px,2vw,24px)] text-[rgba(27,27,27,.9)] max-w-[60ch] mb-3.5 font-semibold leading-[1.3]" data-id="element-21">
                  Control de plagas sin citas, sin técnicos y sin extraños en tu
                  casa.
                  <br data-id="element-22" />
                  Aplica en minutos y mantén tu hogar protegido todo el año.
                </p>

                <p className="text-lg text-[rgba(27,27,27,.85)] max-w-[60ch] mb-3.5" data-id="element-23">
                  Recibe tu kit, aplica cada 3 meses y crea una barrera
                  constante en interior y exterior (hasta 500 m²). Ideal para
                  hogar o negocio.
                </p>

                <ul className="mt-4 space-y-2.5 list-none p-0" data-id="element-24">
                  {[{
                  text: '1 envío anual con todo lo necesario para 4 aplicaciones',
                  color: 'from-[var(--green-bright)] to-[var(--mint-bright)]'
                }, {
                  text: 'Solo $700 por fumigación (vs. $1,500-2,500 por visita)',
                  color: 'from-[var(--gold-bright)] to-[var(--gold)]'
                }, {
                  text: 'Acción rápida y protección duradera (hasta 3 meses)',
                  color: 'from-[var(--orange)] to-[var(--gold-bright)]'
                }, {
                  text: 'Fumiga en 15-25 min · Fácil y rápido',
                  color: 'from-[var(--blue)] to-[var(--green-bright)]'
                }, {
                  text: 'Recordatorios por WhatsApp + soporte',
                  color: 'from-[var(--purple)] to-[var(--blue)]'
                }].map((item, i) => <li key={i} className="flex gap-2.5 items-start text-[rgba(27,27,27,.86)]" data-id="element-25">
                      <span className={`w-[22px] h-[22px] rounded-[7px] bg-gradient-to-br ${item.color} border-2 border-white shadow-md grid place-items-center flex-shrink-0 mt-[1px] text-white`} data-id="element-26">
                        <Check size={14} strokeWidth={4} data-id="element-27" />
                      </span>
                      {item.text}
                    </li>)}
                </ul>

                <div className="flex gap-3 flex-wrap mt-[18px] mb-2.5" data-id="element-28">
                  <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary pulse-glow" data-id="element-29">
                    Suscribirme por $2,799/año
                  </a>
                  <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline" data-id="element-30">
                    Hablar con un experto
                  </a>
                </div>

                <div className="flex flex-wrap gap-2.5 mt-2.5" data-id="element-31">
                  {[{
                  text: 'Envío gratis',
                  gradient: 'from-[var(--blue)] to-[var(--green-bright)]'
                }, {
                  text: 'Hasta 500 m²',
                  gradient: 'from-[var(--gold-bright)] to-[var(--orange)]'
                }, {
                  text: 'Hogar + Comercio',
                  gradient: 'from-[var(--purple)] to-[var(--blue)]'
                }, {
                  text: 'Cancela cuando quieras',
                  gradient: 'from-[var(--green-bright)] to-[var(--mint-bright)]'
                }].map((tag, i) => <span key={i} className={`inline-flex items-center gap-2.5 px-3 py-2 rounded-full bg-gradient-to-r ${tag.gradient} text-white font-bold text-[13px] shadow-md border-2 border-white`} data-id="element-32">
                      {tag.text}
                    </span>)}
                </div>

                <p className="text-[12.5px] text-[rgba(91,91,91,.9)] mt-2.5 leading-snug" data-id="element-33">
                  *Buggy es un plan <strong data-id="element-34">preventivo</strong>. No es para
                  infestaciones fuera de control. No cubre termitas ni roedores.
                  La garantía de refuerzo aplica con checklist y condiciones en
                  FAQs.
                </p>

                {/* Mensaje para espacios grandes */}
                <div className="mt-4 p-3 rounded-xl bg-gradient-to-r from-[rgba(74,144,226,.1)] to-[rgba(155,111,232,.1)] border border-[rgba(74,144,226,.25)]" data-id="element-35">
                  <p className="text-[13px] text-[var(--muted)] m-0" data-id="element-36">
                    <strong className="text-[var(--blue)]" data-id="element-37">
                      ¿Más de 500 m²?
                    </strong>{' '}
                    Contáctanos por{' '}
                    <a href={WHATSAPP_URL} onClick={trackLead} className="text-[var(--green)] font-bold underline hover:text-[var(--green-bright)]" data-id="element-38">
                      WhatsApp
                    </a>{' '}
                    para una cotización personalizada con uno de nuestros
                    ejecutivos.
                  </p>
                </div>
              </div>

              {/* Hero Card */}
              <div className="hero-card-gradient bg-gradient-to-br from-white via-[rgba(168,230,193,.15)] to-[rgba(244,197,99,.1)] border-2 border-[var(--green-bright)] rounded-[var(--radius2)] shadow-2xl p-[18px] overflow-hidden relative" data-id="element-39">
                <div className="relative h-[320px] rounded-[20px] bg-gradient-to-b from-[rgba(168,230,193,.9)] via-[rgba(207,231,215,.6)] to-[rgba(255,255,255,0)] border-2 border-dashed border-[var(--green-bright)] flex items-center justify-center overflow-hidden shadow-inner p-6" aria-label="Ilustración Buggy" data-id="element-40">
                  <img src="https://cdn.magicpatterns.com/uploads/ov8KUwvA4iXCi9v3mmkY6i/ChatGPT_Image_28_ene_2026,_10_33_55_a.m..png" alt="Buggy - Control de plagas DIY" className="max-w-full max-h-full object-contain animate-float" data-id="element-41" />
                </div>

                <div className="h-px bg-gradient-to-r from-transparent via-[var(--gold-bright)] to-transparent mt-3 mb-0 shadow-sm" data-id="element-42"></div>

                <div className="flex items-start justify-between gap-[18px] flex-wrap mt-3.5" data-id="element-43">
                  <div data-id="element-44">
                    <h3 className="text-[18px] mb-1.5 bg-gradient-to-r from-[var(--green)] to-[var(--green-bright)] bg-clip-text text-transparent font-black" data-id="element-45">
                      Plan Buggy 365
                    </h3>
                    <p className="m-0 text-[var(--muted)] text-base" data-id="element-46">
                      1 envío anual · 4 aplicaciones · Hasta 500 m² · Hogar o
                      comercio
                    </p>
                  </div>
                  <div className="inline-flex flex-col gap-0.5 px-3.5 py-3 rounded-2xl bg-gradient-to-br from-[var(--mint-bright)] to-[var(--mint)] border-2 border-[var(--green-bright)] text-[var(--green)] min-w-[210px] shadow-lg" data-id="element-47">
                    <div className="text-[26px] font-black tracking-[-0.3px] leading-none" data-id="element-48">
                      $2,799
                    </div>
                    <div className="text-[13px] text-[rgba(31,94,67,.85)] font-bold" data-id="element-49">
                      MXN / año (1 envío completo)
                    </div>
                    <div className="text-[11px] text-[rgba(31,94,67,.7)] font-semibold mt-1" data-id="element-50">
                      ≈ $700 por fumigación
                    </div>
                  </div>
                </div>

                <div className="mt-3 flex gap-2.5 flex-wrap" data-id="element-51">
                  {[{
                  text: 'Sin citas',
                  gradient: 'from-[var(--gold-bright)] to-[var(--orange)]'
                }, {
                  text: 'Sin extraños en casa',
                  gradient: 'from-[var(--blue)] to-[var(--purple)]'
                }, {
                  text: 'Preventivo',
                  gradient: 'from-[var(--green-bright)] to-[var(--mint-bright)]'
                }].map((tag, i) => <span key={i} className={`inline-flex items-center gap-2 px-2.5 py-[7px] rounded-full bg-gradient-to-r ${tag.gradient} text-white font-extrabold text-[12.5px] shadow-md border border-white`} data-id="element-52">
                      {tag.text}
                    </span>)}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* PROBLEM SECTION */}
        <section className="py-[68px]" data-id="element-53">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-54">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-[900px]:grid-cols-1" data-id="element-55">
              <div data-id="element-56">
                <h2 className="text-[clamp(24px,2.4vw,34px)] mb-3.5 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-57">
                  Lo caro no es fumigar… es tener que hacerlo una y otra vez
                </h2>
                <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-58">
                  La mayoría de hogares no necesita "una fumigación intensa"
                  cada vez que aparece algo. Lo que realmente funciona a largo
                  plazo es <strong data-id="element-59">prevención constante</strong>: mantener una
                  barrera en puntos clave y repetirla con frecuencia.
                </p>
                <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-60">
                  Buggy convierte el control de plagas en un hábito simple
                  (trimestral) para que no dependas de visitas, horarios ni
                  improvisaciones.
                </p>
              </div>

              <div className="bg-gradient-to-br from-white to-[rgba(168,230,193,.2)] border-2 border-[var(--green-bright)] rounded-[var(--radius)] shadow-xl p-[18px]" data-id="element-61">
                <div className="w-10 h-10 rounded-[14px] bg-gradient-to-br from-[var(--orange)] to-[var(--gold-bright)] border-2 border-white shadow-lg grid place-items-center text-white font-black mb-2.5" data-id="element-62">
                  !
                </div>
                <h3 className="text-[18px] mb-2 bg-gradient-to-r from-[var(--green)] to-[var(--green-bright)] bg-clip-text text-transparent font-black" data-id="element-63">
                  Si esto te suena, Buggy es para ti
                </h3>
                <ul className="mt-2.5 space-y-2.5 list-none p-0" data-id="element-64">
                  {['Pagas por visita y el problema regresa', 'Te piden esperar en casa "a ver a qué hora llegan"', 'No quieres meter extraños a tu hogar', 'Aerosoles que solo "matan lo que ves"', 'No sabes qué usar, dónde aplicar y cada cuándo'].map((item, i) => <li key={i} className="flex gap-2.5 items-start text-[rgba(27,27,27,.86)]" data-id="element-65">
                      <span className="w-[22px] h-[22px] rounded-[7px] bg-[rgba(168,230,193,.75)] border border-[rgba(31,94,67,.2)] grid place-items-center flex-shrink-0 mt-[1px] text-[var(--green)]" data-id="element-66">
                        <Check size={14} strokeWidth={4} data-id="element-67" />
                      </span>
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="py-[68px] pt-0" data-id="element-68">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-69">
            <h2 className="text-[clamp(24px,2.4vw,34px)] mb-3.5 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-70">
              Cómo funciona Buggy (en 3 pasos)
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-[900px]:grid-cols-1" data-id="element-71">
              {[{
              icon: '1',
              title: 'Recibe tu Kit Completo',
              text: 'Todo lo necesario para el año: bomba/aspersor recargable, bolsa de aplicación, protección, guía rápida y dosis para 4 aplicaciones trimestrales.',
              gradient: 'from-[var(--green-bright)] to-[var(--mint-bright)]'
            }, {
              icon: '2',
              title: 'Aplica cada 3 meses (15–25 min)',
              text: 'Aplicación dirigida en perímetros, entradas, grietas y zonas clave. Interior + exterior. Rápido y fácil.',
              gradient: 'from-[var(--gold-bright)] to-[var(--orange)]'
            }, {
              icon: '3',
              title: 'Mantén tu calendario',
              text: 'Usa tu checklist trimestral y recibe recordatorios por WhatsApp para mantener una barrera constante todo el año.',
              gradient: 'from-[var(--blue)] to-[var(--purple)]'
            }].map((step, i) => <div key={i} className="bg-gradient-to-br from-white to-[rgba(168,230,193,.15)] border-2 border-[var(--green-bright)] rounded-[var(--radius)] shadow-xl p-[18px] hover:shadow-2xl hover:-translate-y-1 transition-all" data-id="element-72">
                  <div className={`w-10 h-10 rounded-[14px] bg-gradient-to-br ${step.gradient} border-2 border-white shadow-lg grid place-items-center text-white font-black mb-2.5`} data-id="element-73">
                    {step.icon}
                  </div>
                  <h3 className="text-[18px] mb-2 bg-gradient-to-r from-[var(--green)] to-[var(--green-bright)] bg-clip-text text-transparent font-black" data-id="element-74">
                    {step.title}
                  </h3>
                  <p className="mb-0 text-[var(--muted)] text-base" data-id="element-75">
                    {step.text}
                  </p>
                </div>)}
            </div>
            <div className="mt-[18px] flex gap-3 flex-wrap" data-id="element-76">
              <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary" data-id="element-77">
                Suscribirme $2,799/año
              </a>
              <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline" data-id="element-78">
                Tengo dudas → WhatsApp
              </a>
            </div>
          </div>
        </section>

        {/* WHAT'S INCLUDED */}
        <section className="py-[68px]" data-id="element-79">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-80">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start max-[900px]:grid-cols-1" data-id="element-81">
              <div data-id="element-82">
                <h2 className="text-[clamp(24px,2.4vw,34px)] mb-3.5 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-83">
                  ¿Qué incluye tu suscripción anual?
                </h2>
                <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-84">
                  Todo lo necesario para mantener tu hogar protegido durante el
                  año. <strong data-id="element-85">Recibes todo en un solo envío</strong> al inicio.
                </p>

                <div className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px] mt-3.5" data-id="element-86">
                  <div className="flex items-start justify-between gap-[18px] flex-wrap" data-id="element-87">
                    <div data-id="element-88">
                      <h3 className="text-[18px] mb-1 text-[var(--green)] font-bold" data-id="element-89">
                        Plan Buggy 365
                      </h3>
                      <p className="m-0 text-[var(--muted)] text-base" data-id="element-90">
                        1 envío anual · 4 aplicaciones · Hasta 500 m²
                      </p>
                    </div>
                    <div className="inline-flex flex-col gap-0.5 px-3.5 py-3 rounded-2xl bg-[rgba(207,231,215,.6)] border border-[rgba(31,94,67,.2)] text-[var(--green)] min-w-[140px]" data-id="element-91">
                      <div className="text-[26px] font-black tracking-[-0.3px] leading-none" data-id="element-92">
                        $2,799
                      </div>
                      <div className="text-[13px] text-[rgba(31,94,67,.85)] font-bold" data-id="element-93">
                        MXN / año
                      </div>
                      <div className="text-[11px] text-[rgba(31,94,67,.7)] font-semibold mt-0.5" data-id="element-94">
                        $700 por fumigación
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 flex gap-3 flex-wrap" data-id="element-95">
                    <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary" data-id="element-96">
                      Suscribirme
                    </a>
                    <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline" data-id="element-97">
                      Hablar por WhatsApp
                    </a>
                  </div>

                  <p className="text-[12.5px] text-[rgba(91,91,91,.9)] mt-2.5" data-id="element-98">
                    Cancelas cuando quieras. 1 envío anual con todo incluido.
                    Envío gratis.
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-99">
                {[{
                icon: '📦',
                title: 'Kit completo (1 envío)',
                text: 'Bomba/aspersor recargable + bolsa de aplicación + guantes + lentes + guía rápida + todo para 4 aplicaciones.',
                gradient: 'from-[var(--gold-bright)] to-[var(--orange)]'
              }, {
                icon: '4×',
                title: 'Dosis para 4 aplicaciones',
                text: 'Todo lo necesario para aplicar cada 3 meses durante el año completo.',
                gradient: 'from-[var(--green-bright)] to-[var(--mint-bright)]'
              }, {
                icon: '▶',
                title: 'Tutoriales',
                text: 'Videos cortos: mezcla, dónde aplicar y errores comunes.',
                gradient: 'from-[var(--blue)] to-[var(--purple)]'
              }, {
                icon: 'WA',
                title: 'Soporte por WhatsApp',
                text: 'Te ayudamos antes y después de aplicar. Además, te enviamos recordatorios trimestrales para que no olvides tu aplicación.',
                gradient: 'from-[var(--purple)] to-[var(--blue)]'
              }].map((item, i) => <div key={i} className="bg-gradient-to-br from-white to-[rgba(168,230,193,.15)] border-2 border-[var(--green-bright)] rounded-[var(--radius)] shadow-xl p-[18px] hover:shadow-2xl hover:-translate-y-1 transition-all" data-id="element-100">
                    <div className={`w-10 h-10 rounded-[14px] bg-gradient-to-br ${item.gradient} border-2 border-white shadow-lg grid place-items-center text-white font-black mb-2.5 text-lg`} data-id="element-101">
                      {item.icon}
                    </div>
                    <h3 className="text-[18px] mb-2 bg-gradient-to-r from-[var(--green)] to-[var(--green-bright)] bg-clip-text text-transparent font-black" data-id="element-102">
                      {item.title}
                    </h3>
                    <p className="mb-0 text-[var(--muted)] text-base" data-id="element-103">
                      {item.text}
                    </p>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* PEST COVERAGE */}
        <section className="py-[68px] pt-0" data-id="element-104">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-105">
            {/* Hero Statement */}
            <div className="text-center mb-12" data-id="element-106">
              <h2 className="text-[clamp(32px,3.5vw,48px)] leading-[1.1] mb-6 tracking-[-0.5px] bg-gradient-to-br from-[var(--green)] via-[var(--green-bright)] to-[var(--green2)] bg-clip-text text-transparent font-black" data-id="element-107">
                Controla casi todas las plagas del hogar y comercio.
              </h2>

              <p className="text-lg text-[rgba(27,27,27,.85)] max-w-[75ch] mx-auto mb-8" data-id="element-108">
                Buggy está diseñado como <strong data-id="element-109">plan preventivo</strong> para{' '}
                <strong data-id="element-110">más de 100 plagas domésticas comunes</strong>. La
                efectividad depende de aplicar en los puntos correctos y
                mantener el calendario trimestral.
              </p>

              {/* Pest Illustration */}
              <div className="mb-8 flex justify-center" data-id="element-111">
                <div className="relative max-w-[800px] w-full rounded-[var(--radius2)] overflow-hidden shadow-2xl border-2 border-[var(--green-bright)]" data-id="element-112">
                  <img src="https://cdn.magicpatterns.com/uploads/uEAZXr2xfsZxZcYXFx8Hxj/ChatGPT_Image_28_ene_2026,_10_26_44_a.m..png" alt="Ilustración de plagas que controla Buggy" className="w-full h-auto" data-id="element-113" />
                </div>
              </div>

              {/* Pest Categories */}
              <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-114">
                {['Arañas', 'Hormigas', 'Cucarachas', 'Pececillos de plata', 'Tijerillas', 'Ciempiés', '100+ Más'].map((pest, i) => <span key={i} className="inline-flex items-center px-4 py-2.5 rounded-full bg-gradient-to-r from-[var(--mint-bright)] to-[var(--mint)] border-2 border-[var(--green-bright)] text-[var(--green)] font-bold text-[15px] shadow-md" data-id="element-115">
                    {pest}
                  </span>)}
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4 max-[900px]:grid-cols-1" data-id="element-116">
              <div className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px]" data-id="element-117">
                <h3 className="text-[18px] mb-2 text-[var(--green)] font-bold" data-id="element-118">
                  Efectivo contra
                </h3>
                <p className="mb-0 text-[var(--muted)] text-base" data-id="element-119">
                  Plagas rastreras y voladoras comunes del hogar.{' '}
                  <strong data-id="element-120">Acción rápida y protección duradera</strong> con
                  control preventivo en perímetros, entradas y zonas clave. La
                  aplicación trimestral constante mantiene una barrera efectiva
                  contra reinfestaciones.
                </p>
              </div>

              <div className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px]" data-id="element-121">
                <h3 className="text-[18px] mb-2 text-[var(--green)] font-bold" data-id="element-122">
                  No está diseñado para
                </h3>
                <ul className="mt-2.5 space-y-2.5 list-none p-0" data-id="element-123">
                  {['Termitas', 'Roedores (ratas/ratones)', 'Infestaciones fuera de control'].map((item, i) => <li key={i} className="flex gap-2.5 items-start text-[rgba(27,27,27,.86)]" data-id="element-124">
                      <span className="w-[22px] h-[22px] rounded-[7px] bg-gray-100 border border-gray-200 grid place-items-center flex-shrink-0 mt-[1px] text-gray-400 font-bold text-xs" data-id="element-125">
                        —
                      </span>
                      {item}
                    </li>)}
                </ul>

                <div className="h-px bg-gradient-to-r from-transparent via-[rgba(31,94,67,.22)] to-transparent mt-3 mb-0" data-id="element-126"></div>

                <h3 className="text-[18px] mt-3.5 mb-2 text-[var(--green)] font-bold" data-id="element-127">
                  ¿No sabes si Buggy es para tu caso?
                </h3>
                <p className="mb-2.5 text-[var(--muted)] text-base" data-id="element-128">
                  Escríbenos por WhatsApp y te decimos el mejor protocolo antes
                  de comprar.
                </p>
                <div className="flex gap-3 flex-wrap mt-2.5" data-id="element-129">
                  <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline" data-id="element-130">
                    Hablar por WhatsApp
                  </a>
                  <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary" data-id="element-131">
                    Suscribirme
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* COMPARISON TABLE */}
        <section className="py-[68px]" data-id="element-132">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-133">
            <h2 className="text-[clamp(24px,2.4vw,34px)] mb-3.5 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-134">
              Buggy vs. lo de siempre
            </h2>
            <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-135">
              Comparación práctica para un hogar o comercio típico que quiere
              prevenir, no reaccionar tarde.
            </p>

            <div className="mt-3.5 overflow-x-auto" data-id="element-136">
              <table className="w-full border-separate border-spacing-0 overflow-hidden rounded-[16px] border-2 border-[var(--green-bright)] bg-[rgba(255,255,255,.85)] min-w-[600px]" aria-label="Comparativo Buggy" data-id="element-137">
                <thead data-id="element-138">
                  <tr data-id="element-139">
                    <th className="p-[14px_12px] border-b-[3px] border-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px] bg-[rgba(207,231,215,.45)] text-[var(--green)] font-black" data-id="element-140">
                      {' '}
                    </th>
                    <th className="p-[14px_12px] border-b-[3px] border-[var(--green-bright)] border-l border-l-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px] bg-[rgba(168,230,193,.25)] text-[var(--green)] font-black" data-id="element-141">
                      Buggy (anual)
                    </th>
                    <th className="p-[14px_12px] border-b-[3px] border-[var(--green-bright)] border-l border-l-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px] bg-[rgba(207,231,215,.45)] text-[var(--green)] font-black" data-id="element-142">
                      Fumigación por visita
                    </th>
                    <th className="p-[14px_12px] border-b-[3px] border-[var(--green-bright)] border-l border-l-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px] bg-[rgba(207,231,215,.45)] text-[var(--green)] font-black" data-id="element-143">
                      Aerosoles / súper
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-144">
                  {[['Costo por aplicación', '$700 (4 aplicaciones)', '$1,500-2,500 por visita', '$200-400 (se acumula)'], ['Costo anual', '$2,799 (todo incluido)', '$6,000-10,000+ (4 visitas)', '$800-1,600+ (compras repetidas)'], ['Envío', 'Gratis siempre', 'Variable', 'Variable'], ['Efectividad', 'Alta (preventivo constante)', 'Media (reactivo)', 'Baja (solo mata lo que ves)'], ['Duración de protección', 'Hasta 3 meses (acción rápida y duradera)', '1-2 semanas', 'Minutos (temporal)'], ['Tiempo de aplicación', '15-25 min (fácil y rápido)', '1-2 horas (esperar técnico)', '5-10 min (temporal)'], ['Todo en 1 envío', 'Sí', 'No', 'No'], ['Sin citas', 'Sí', 'No', 'Sí'], ['Prevención (plan)', 'Sí (trimestral)', 'Depende del servicio', 'No'], ['Tú decides cuándo', 'Sí', 'No', 'Sí'], ['Recordatorios', 'Sí (WhatsApp)', 'No', 'No'], ['Guía + soporte', 'Sí (WhatsApp + tutoriales)', 'Variable', 'No'], ['Entra alguien a tu casa', 'No', 'Sí', 'No'], ['Para hogar y comercio', 'Sí', 'Sí', 'Sí'], ['Cancelación', 'Cuando quieras', 'Depende del contrato', 'N/A']].map((row, i) => <tr key={i} data-id="element-145">
                      <td className="p-[14px_12px] border-b border-b-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px] font-bold" data-id="element-146">
                        {row[0]}
                      </td>
                      <td className="p-[14px_12px] border-b border-b-[var(--green-bright)] border-l border-l-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px] bg-[rgba(168,230,193,.12)]" data-id="element-147">
                        {row[1]}
                      </td>
                      <td className="p-[14px_12px] border-b border-b-[var(--green-bright)] border-l border-l-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px]" data-id="element-148">
                        {row[2]}
                      </td>
                      <td className="p-[14px_12px] border-b border-b-[var(--green-bright)] border-l border-l-[var(--green-bright)] text-left align-top text-[rgba(27,27,27,.88)] text-[14px]" data-id="element-149">
                        {row[3]}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* SAFETY / TRUST */}
        <section className="py-[68px] pt-0" data-id="element-150">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-151">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-[900px]:grid-cols-1" data-id="element-152">
              <div className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px]" data-id="element-153">
                <h2 className="text-[clamp(24px,2.4vw,34px)] mb-2 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-154">
                  Uso residencial y comercial, con guía clara
                </h2>
                <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-155">
                  Buggy está diseñado para que una persona sin experiencia pueda
                  aplicar de forma simple en hogares y comercios:{' '}
                  <strong data-id="element-156">dosis guiada</strong>,{' '}
                  <strong data-id="element-157">dónde sí / dónde no</strong>, y{' '}
                  <strong data-id="element-158">checklist</strong>.
                </p>
                <ul className="mt-2.5 space-y-2.5 list-none p-0" data-id="element-159">
                  {['Checklist de ventilación y tiempos recomendados', '"Errores comunes" para evitar sobreaplicar', 'Soporte por WhatsApp si tienes dudas'].map((item, i) => <li key={i} className="flex gap-2.5 items-start text-[rgba(27,27,27,.86)]" data-id="element-160">
                      <span className="w-[22px] h-[22px] rounded-[7px] bg-[rgba(168,230,193,.75)] border border-[rgba(31,94,67,.2)] grid place-items-center flex-shrink-0 mt-[1px] text-[var(--green)]" data-id="element-161">
                        <Check size={14} strokeWidth={4} data-id="element-162" />
                      </span>
                      {item}
                    </li>)}
                </ul>
                <div className="flex gap-3 flex-wrap mt-3" data-id="element-163">
                  <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline" data-id="element-164">
                    Quiero asesoría por WhatsApp
                  </a>
                </div>
                <p className="text-[12.5px] text-[rgba(91,91,91,.9)] mt-2.5" data-id="element-165">
                  No prometemos "cero bichos jamás". Prometemos un sistema
                  preventivo constante y guiado para reducir y controlar plagas
                  comunes.
                </p>
              </div>

              <div className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px]" data-id="element-166">
                <h2 className="text-[clamp(24px,2.4vw,34px)] mb-2 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-167">
                  Garantía de refuerzo Buggy
                </h2>
                <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-168">
                  Si aplicas siguiendo nuestras instrucciones y sigues viendo
                  actividad, te mandamos un <strong data-id="element-169">refuerzo</strong> para
                  ayudarte a controlar el problema.
                </p>
                <ul className="mt-2.5 space-y-2.5 list-none p-0" data-id="element-170">
                  {['1 refuerzo por año por domicilio', 'Checklist breve para validar aplicación', 'Envío del refuerzo sin costo'].map((item, i) => <li key={i} className="flex gap-2.5 items-start text-[rgba(27,27,27,.86)]" data-id="element-171">
                      <span className="w-[22px] h-[22px] rounded-[7px] bg-[rgba(168,230,193,.75)] border border-[rgba(31,94,67,.2)] grid place-items-center flex-shrink-0 mt-[1px] text-[var(--green)]" data-id="element-172">
                        <Check size={14} strokeWidth={4} data-id="element-173" />
                      </span>
                      {item}
                    </li>)}
                </ul>
                <div className="flex gap-3 flex-wrap mt-3" data-id="element-174">
                  <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary" data-id="element-175">
                    Suscribirme $2,799/año
                  </a>
                </div>
                <p className="text-[12.5px] text-[rgba(91,91,91,.9)] mt-2.5" data-id="element-176">
                  Detalles y condiciones en FAQs (abajo).
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* PET & PEOPLE SAFE */}
        <section className="py-[68px] pt-0" data-id="element-177">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-178">
            <div className="grid grid-cols-1 md:grid-cols-[1fr_1.1fr] gap-6 items-center max-[900px]:grid-cols-1" data-id="element-179">
              {/* Image */}
              <div className="relative rounded-[var(--radius2)] overflow-hidden shadow-2xl border-2 border-[var(--green-bright)]" data-id="element-180">
                <img src="https://cdn.magicpatterns.com/uploads/qsRa9gVyvuPepXXJ3sBefV/ChatGPT_Image_28_ene_2026,_10_43_11_a.m..png" alt="Buggy es seguro para mascotas y personas" className="w-full h-auto" data-id="element-181" />
              </div>

              {/* Content */}
              <div className="bg-gradient-to-br from-[var(--orange)] to-[var(--gold-bright)] rounded-[var(--radius2)] shadow-2xl p-8 text-white" data-id="element-182">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold text-[13px] mb-4" data-id="element-183">
                  SIN QUÍMICOS AGRESIVOS
                </div>

                <h2 className="text-[clamp(28px,3vw,42px)] leading-[1.1] mb-4 tracking-[-0.4px] font-black" data-id="element-184">
                  Diseñado para personas, mascotas y el planeta.
                </h2>

                <p className="text-[17px] mb-4 text-white/95 leading-relaxed" data-id="element-185">
                  No deberías tener que declarar guerra nuclear en tu hogar para
                  deshacerte de las plagas. Cada producto que enviamos puede
                  usarse alrededor de personas y mascotas—incluso se usan en
                  hospitales, asilos y clínicas veterinarias.
                </p>

                <p className="text-[17px] mb-6 text-white/95 leading-relaxed" data-id="element-186">
                  Cada envío incluye instrucciones sobre cómo ayudar a proteger
                  abejas y el medio ambiente. Creemos en mantener tu ecosistema
                  y el ecosistema de las plagas separados.
                </p>

                <div className="flex gap-3 flex-wrap" data-id="element-187">
                  <a href={CHECKOUT_URL} onClick={trackLead} className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white text-[var(--orange)] font-bold shadow-lg hover:shadow-xl hover:scale-105 transition-all" data-id="element-188">
                    Suscribirme ahora
                  </a>
                  <a href={WHATSAPP_URL} onClick={trackLead} className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white/20 backdrop-blur-sm border-2 border-white text-white font-bold hover:bg-white/30 transition-all" data-id="element-189">
                    Más información
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section className="py-[68px]" data-id="element-190">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-191">
            <h2 className="text-[clamp(24px,2.4vw,34px)] mb-3.5 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-192">
              Nuestros clientes nos aman, los bichos nos odian
            </h2>
            <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-193">
              Testimonios de ejemplo (sustitúyelos por reseñas reales con ciudad
              y foto con permiso).
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-3.5 max-[900px]:grid-cols-1" data-id="element-194">
              {[{
              title: '“Se nota el cambio en 2 aplicaciones”',
              text: '“Pagábamos visitas sueltas y siempre regresaba. Con Buggy lo hacemos cada 3 meses y se nota el cambio.”',
              author: '— Mariana G., Querétaro'
            }, {
              title: '“Los videos están clarísimos”',
              text: '“Me daba miedo usar algo mal. Los videos y el checklist te dicen exactamente qué hacer.”',
              author: '— Luis A., Monterrey'
            }, {
              title: '“Ideal para mantenimiento preventivo”',
              text: '“Me encanta que llega el refill cuando toca. Ya no coordino citas ni espero a nadie.”',
              author: '— Sofía R., CDMX'
            }, {
              title: '“Dejé de depender de aerosoles”',
              text: '“Con aerosoles era estar batallando cada semana. Con el plan trimestral es otra historia.”',
              author: '— Carlos M., Guadalajara'
            }].map((t, i) => <div key={i} className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px]" data-id="element-195">
                  <h3 className="text-[18px] mb-2 text-[var(--green)] font-bold" data-id="element-196">
                    {t.title}
                  </h3>
                  <p className="mb-0 text-[var(--muted)] text-base" data-id="element-197">{t.text}</p>
                  <p className="text-[12.5px] text-[rgba(91,91,91,.9)] mt-2.5" data-id="element-198">
                    {t.author}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* FAQ + POLICIES */}
        <section id="faq" className="py-[68px] pt-0" data-id="element-199">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-200">
            <h2 className="text-[clamp(24px,2.4vw,34px)] mb-3.5 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-201">
              Preguntas frecuentes
            </h2>
            <p className="mb-3.5 text-[var(--muted)] text-base" data-id="element-202">
              Respuestas rápidas para decidir con confianza.
            </p>

            <div className="mt-3.5 space-y-2.5" data-id="element-203">
              {[{
              q: '¿Buggy es para plagas fuera de control?',
              a: 'Buggy es un <strong>plan preventivo</strong>. Si ya tienes una infestación severa, puede requerirse un protocolo adicional. Escríbenos por WhatsApp y te orientamos antes de comprar.'
            }, {
              q: '¿Cada envío alcanza para qué tamaño?',
              a: 'Recibes <strong>todo en un solo envío anual</strong> con dosis para 4 aplicaciones. Cada aplicación cubre <strong>hasta 500 m²</strong> en total (interior + exterior), siguiendo la aplicación dirigida que indicamos.'
            }, {
              q: '¿Cada cuándo se aplica?',
              a: '<strong>Cada 3 meses</strong>. Recibes todo al inicio del año y tú decides cuándo aplicar siguiendo el calendario trimestral. Mantener este ritmo es clave para que la barrera preventiva se sostenga.'
            }, {
              q: '¿Qué plagas NO cubre?',
              a: 'Buggy no está diseñado para <strong>termitas</strong> ni <strong>roedores</strong> (ratas/ratones). Para esos casos se requieren métodos y manejo especializado.'
            }, {
              q: '¿Cómo funciona la Garantía de Refuerzo?',
              a: 'Si aplicas siguiendo nuestras instrucciones y sigues viendo actividad, te enviamos <strong>1 refuerzo por año por domicilio</strong>. Para activarla te pedimos: <ul><li>Confirmar que aplicaste dentro del periodo recomendado</li><li>Responder un checklist breve (3–5 preguntas)</li><li>Enviar fotos del área donde notas actividad</li></ul> Esto nos ayuda a ajustar el protocolo y evitar errores comunes de aplicación.'
            }, {
              q: '¿Puedo cancelar? ¿Hay reembolsos?',
              a: '<strong>Cancelación:</strong> puedes cancelar en cualquier momento para detener cargos futuros.<br/><br/><strong>Reembolsos:</strong><ul><li>Si tu pedido <strong>aún no se envía</strong>: reembolso completo.</li><li>Si el <strong>kit ya fue enviado</strong>: se puede otorgar reembolso <strong>prorrateado</strong> de dosis no utilizadas, descontando el costo del kit y envío.</li><li>Los productos ya usados se consideran no reembolsables por tratarse de uso personal.</li></ul><strong>Tip:</strong> si tu preocupación es "¿y si no funciona?", normalmente lo mejor es activar la <strong>Garantía de Refuerzo</strong> para ajustar el protocolo.'
            }, {
              q: '¿Hacen envíos a todo México?',
              a: 'Sí. Los tiempos de entrega pueden variar por zona y disponibilidad de paquetería. Recibes todo en un solo envío al inicio de tu suscripción.'
            }].map((faq, i) => <details key={i} className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[16px] p-[14px] group" open={i === 0} data-id="element-204">
                  <summary className="cursor-pointer font-black text-[rgba(27,27,27,.92)] flex items-center justify-between" data-id="element-205">
                    {faq.q}
                    <span className="transform transition-transform group-open:rotate-180 text-[var(--green)]" data-id="element-206">
                      ▼
                    </span>
                  </summary>
                  <div className="mt-2.5 text-[var(--muted)] text-[14.5px] leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mt-2 [&_li]:mb-1" dangerouslySetInnerHTML={{
                __html: faq.a
              }} data-id="element-207" />
                </details>)}
            </div>

            <div className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px] mt-[18px]" data-id="element-208">
              <h3 className="text-[18px] mb-1.5 text-[var(--green)] font-bold" data-id="element-209">
                ¿Quieres que un experto te confirme si Buggy es para tu caso?
              </h3>
              <p className="mb-3 text-[var(--muted)] text-base" data-id="element-210">
                Escríbenos por WhatsApp y te recomendamos el mejor protocolo
                antes de comprar.
              </p>
              <div className="flex gap-3 flex-wrap" data-id="element-211">
                <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline" data-id="element-212">
                  Hablar por WhatsApp
                </a>
                <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary" data-id="element-213">
                  Suscribirme $2,799/año
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="py-[68px] pt-0" data-id="element-214">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-215">
            <div className="bg-[rgba(255,255,255,.85)] border border-[rgba(31,94,67,.14)] rounded-[var(--radius)] shadow-[0_10px_22px_rgba(0,0,0,.05)] p-[18px] flex flex-wrap gap-[14px] items-center justify-between" data-id="element-216">
              <div className="min-w-[240px]" data-id="element-217">
                <h2 className="text-[clamp(24px,2.4vw,34px)] mb-2 tracking-[-0.3px] text-[var(--green)] font-bold" data-id="element-218">
                  Protege tu hogar o comercio todo el año
                </h2>
                <p className="m-0 text-[var(--muted)] text-base" data-id="element-219">
                  1 envío anual con todo · Envío gratis · 4 aplicaciones · Hasta
                  500 m² · Solo $700 por fumigación · Fácil y rápido (15-25 min)
                  · Cancela cuando quieras
                </p>
              </div>
              <div className="flex gap-3 flex-wrap" data-id="element-220">
                <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary" data-id="element-221">
                  Suscribirme por $2,799/año
                </a>
                <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline" data-id="element-222">
                  Hablar por WhatsApp
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="py-[30px] pb-[90px] text-[13px] text-[rgba(91,91,91,.9)]" data-id="element-223">
          <div className="max-w-[var(--max)] mx-auto px-5" data-id="element-224">
            <div className="flex gap-2.5 flex-wrap items-center justify-between" data-id="element-225">
              <div data-id="element-226">
                <strong className="text-[var(--green)]" data-id="element-227">Buggy</strong> · Control
                de plagas DIY · SAPI de CV · 2026
              </div>
              <div className="flex gap-3 flex-wrap" data-id="element-228">
                <a href="#faq" className="hover:text-[var(--green)]" data-id="element-229">
                  FAQs
                </a>
                <a href={WHATSAPP_URL} onClick={trackLead} className="hover:text-[var(--green)]" data-id="element-230">
                  WhatsApp
                </a>
                <a href={CHECKOUT_URL} onClick={trackLead} className="hover:text-[var(--green)]" data-id="element-231">
                  Suscribirme
                </a>
              </div>
            </div>
            <div className="mt-2.5" data-id="element-232">
              <div className="text-[12.5px] leading-snug" data-id="element-233">
                Buggy es un programa preventivo para plagas domésticas comunes.
                No cubre termitas ni roedores. Recibes todo en un solo envío
                anual. Sigue siempre las instrucciones de uso y seguridad del
                producto.
              </div>
            </div>
          </div>
        </footer>

        {/* Sticky mobile CTAs */}
        <div className="fixed left-0 right-0 bottom-0 bg-[rgba(247,242,232,.85)] backdrop-blur-md border-t border-[rgba(31,94,67,.14)] p-[12px_14px] z-40 block md:hidden" role="navigation" aria-label="Acciones rápidas" data-id="element-234">
          <div className="max-w-[var(--max)] mx-auto flex gap-2.5 items-center justify-between" data-id="element-235">
            <a href={WHATSAPP_URL} onClick={trackLead} className="btn-outline flex-1 text-center justify-center" data-id="element-236">
              WhatsApp
            </a>
            <a href={CHECKOUT_URL} onClick={trackLead} className="btn-primary flex-1 text-center justify-center" data-id="element-237">
              Suscribirme
            </a>
          </div>
        </div>
      </div>

      {/* Tailwind Custom Utility Classes Injection for Buttons */}
      <style data-id="element-238">{`
        .btn-primary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 12px 16px;
          border-radius: 999px;
          border: 2px solid transparent;
          font-weight: 750;
          text-decoration: none;
          transition: transform .08s ease, background .15s ease, border-color .15s ease, box-shadow .15s ease;
          white-space: nowrap;
          background: linear-gradient(135deg, var(--green-bright), var(--green));
          color: #fff;
          box-shadow: 0 10px 25px rgba(58,155,111,.35), 0 0 0 0 rgba(58,155,111,.5);
        }
        .btn-primary:hover {
          background: linear-gradient(135deg, var(--green), var(--green2));
          box-shadow: 0 15px 35px rgba(58,155,111,.45), 0 0 20px rgba(58,155,111,.3);
          transform: translateY(-2px);
        }
        .btn-primary:active {
          transform: scale(.98) translateY(0);
        }
        
        .btn-outline {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 12px 16px;
          border-radius: 999px;
          border: 2px solid var(--green-bright);
          font-weight: 750;
          text-decoration: none;
          transition: transform .08s ease, background .15s ease, border-color .15s ease, box-shadow .15s ease;
          white-space: nowrap;
          background: linear-gradient(135deg, rgba(255,255,255,.85), rgba(168,230,193,.25));
          color: var(--green);
          box-shadow: 0 4px 12px rgba(58,155,111,.15);
        }
        .btn-outline:hover {
          background: linear-gradient(135deg, rgba(168,230,193,.55), rgba(168,230,193,.35));
          border-color: var(--green);
          box-shadow: 0 8px 20px rgba(58,155,111,.25);
          transform: translateY(-2px);
        }
        .btn-outline:active {
          transform: scale(.98) translateY(0);
        }
      `}</style>
    </div>;
}